import { add } from '../../payment-profiles/services/PaymentProfilesService';
import { fetchRecords } from '../../customers/services/CustomersService';
import { fetchRecords as fetchBillingProviders } from '../../billing-providers/services/BillingProvidersService';

const generatePaymentProfileData = (customerId: string, billingProviderId: string) => {
    const profileNames = [
        'Primary Payment Method',
        'Business Credit Card',
        'Personal Visa',
        'Company Mastercard',
        'Backup Payment',
        'Monthly Billing Card',
        'Emergency Payment'
    ];
    
    const name = profileNames[Math.floor(Math.random() * profileNames.length)];
    
    return {
        name,
        description: Math.random() > 0.3 ? `Test payment profile for ${name}` : undefined,
        status: Math.random() > 0.2 ? 'Active' : 'Inactive',
        customerId,
        billingProviderId,
        providerPaymentMethodId: `pm_test_${Math.random().toString(36).substring(2, 15)}`,
        providerSpecificData: JSON.stringify({
            testData: true,
            generatedAt: new Date().toISOString()
        })
    };
};

export const generatePaymentProfilesTestData = async (count: number, customerId?: string) => {
    let targetCustomerId = customerId;
    let billingProviderId: string;
    
    // Get customer if not provided
    if (!targetCustomerId) {
        const customersResponse = await fetchRecords({});
        const customers = customersResponse?.items || [];
        
        if (customers.length === 0) {
            throw new Error('No customers available. Please create customers first.');
        }
        
        targetCustomerId = customers[Math.floor(Math.random() * customers.length)].id;
    }
    
    // Get billing provider
    const providersResponse = await fetchBillingProviders({});
    const providers = providersResponse?.items || [];
    
    if (providers.length === 0) {
        throw new Error('No billing providers available. Please create billing providers first.');
    }
    
    billingProviderId = providers[Math.floor(Math.random() * providers.length)].id;
    
    const promises = [];
    for (let i = 1; i <= count; i++) {
        const data = generatePaymentProfileData(targetCustomerId, billingProviderId);
        promises.push(add(data));
    }
    
    try {
        const results = await Promise.all(promises);
        console.log(`Generated ${count} test payment profiles`);
        return results.filter(Boolean);
    } catch (error) {
        console.error('Error generating payment profile test data:', error);
        return [];
    }
};